module.exports = __webpack_public_path__ + "img/row-drag.7e165f6c.svg";